import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const SHARP_EXTENSIONS = new Set(["jpg", "jpeg", "png", "webp", "gif", "avif"]);

export default function Image({
  src,
  alt,
  imgStyle,
  style,
  className,
  loading = "lazy",
  ...props
}) {
  const isRemote = typeof src === "string" && /^https?:\/\//.test(src);

  const {
    allFile: { edges },
  } = useStaticQuery(graphql`
    query IMAGE_QUERY {
      allFile(
        filter: {
          extension: { in: ["jpg", "jpeg", "png", "webp", "gif", "avif"] }
        }
      ) {
        edges {
          node {
            relativePath
            publicURL
            extension
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `);

  if (isRemote) {
    return (
      <img
        className={className}
        src={src}
        alt={alt}
        loading={loading}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          ...imgStyle,
          ...style,
        }}
        {...props}
      />
    );
  }

  const foundNode = edges.find((edge) => edge.node.relativePath === src);
  if (!foundNode) {
    return null;
  }

  const { childImageSharp, publicURL, extension } = foundNode.node;
  const gatsbyImageData = childImageSharp?.gatsbyImageData;
  const ext = String(extension || "").toLowerCase();

  // SVGs (and any non-sharp asset) - plain <img>, never childImageSharp
  if (!gatsbyImageData || !SHARP_EXTENSIONS.has(ext)) {
    if (!publicURL) {
      return null;
    }
    return (
      <img
        className={className}
        src={publicURL}
        alt={alt}
        loading={loading}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          ...imgStyle,
          ...style,
        }}
        {...props}
      />
    );
  }

  return (
    <GatsbyImage
      image={gatsbyImageData}
      alt={alt}
      className={className}
      style={style}
      imgStyle={imgStyle}
      loading={loading}
      {...props}
    />
  );
}
